@if (data.icon) {
<mat-icon [svgIcon]="data.icon"></mat-icon>
}
<p>{{ data.text }}</p>
